module.exports = __webpack_public_path__ + "img/bubble-confused.c4a2a016.svg";